export function addBreakToBold(str: string): string {
  // TODO: remove space before <strong> & <b> tag
  // so fat this does not work
  return str.replace(/(?!^)<b>/g, "<br/><b>").replace(/(?!^)<strong>/g, "<br/><strong>");
}
